import React, { useCallback, useEffect, useRef, useState } from "react";
import { func, object, string } from "prop-types";
import { get } from "lodash";
import { connect } from "react-redux";

import FilterInput from "../../atoms/FilterInput";
import Input from "../../atoms/Input";

import { paloStoryTypes, storyTemplatesList } from "../../utils/constant";
import { staticTexts } from "../../utils/Translate";

import "./story-type-search-input.m.css";

const StoryTypeSearchInput = ({ query = {}, lang = "bn", domainSlug, navigateToPage }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  let typeTimeoutId;
  const types = domainSlug ? storyTemplatesList : paloStoryTypes;
  const [type, setType] = useState(types.find(({ type }) => type === (query.type || "all"))?.[lang]);

  const onChange = useCallback((e) => {
    const { value = "" } = e.target;
    setType(value);
  }, []);

  const typeClick = (item) => {
    setType(item[lang]);
    clearTimeout(typeTimeoutId);

    typeTimeoutId = setTimeout(() => {
      setOpen(false);

      query.type = item.type;
      const queryString = new URLSearchParams(query).toString();
      navigateToPage(`/search?${queryString}`);
    }, 100);
  };

  const onInputClick = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  useEffect(() => {
    const outsideClick = (event) => {
      if (ref && ref.current && !ref.current.contains(event.target) && !["svg", "use"].includes(event.target.tagName)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", outsideClick);

    return () => document.removeEventListener("click", outsideClick);
  }, []);

  return (
    <div styleName="base" ref={ref}>
      <FilterInput
        type="text"
        styleName="story-type-filter"
        isOpen={open}
        onChange={onChange}
        onInputClick={onInputClick}
        onArrowClick={onInputClick}
        lang={lang}
        id="story-type-input"
        readOnly={true}
        placeHolder={staticTexts(lang).storyTypes}
        value={type}
      />

      {open && (
        <div styleName="dropdown">
          <div styleName="types">
            {types.map((item, index) => (
              <div styleName="type-name" key={index} onClick={() => typeClick(item)}>
                <label styleName="type-text" htmlFor={item.type}>
                  {item[lang]}
                </label>
                <Input
                  styleName="type-radio"
                  id={item.type}
                  value={item.type}
                  checked={type === item[lang]}
                  name="type"
                  type="radio"
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

StoryTypeSearchInput.propTypes = {
  query: object,
  lang: string,
  navigateToPage: func,
  domainSlug: string,
};

const mapStateToProps = (state) => ({
  domainSlug: get(state, ["qt", "config", "domainSlug"]),
});

const mapDispatchToProps = (dispatch) => ({
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoryTypeSearchInput);
